// Auto-generated file created by SVGR source illustrationTemplate.ts
// DO NOT EDIT THIE FILE
import { SVGUniqueID } from './svg-unique-id';
import type { IllustrationProps } from './types';
const Illustration = (props: IllustrationProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={65}
    height={65}
    viewBox="0 0 65 65"
    {...props}
  >
    <g clipPath="url(#clip0_5210_47973)">
      <rect
        width={65}
        height={65}
        rx={32.5}
        fill="#005DE5"
      />
      <path
        d="M48.0444 112.784C41.4273 103.473 27.9264 83.0882 22.9842 53.8915L45.9309 49.968C50.479 77.7466 64.209 93.7157 68.8703 99.9035L48.0444 112.784Z"
        fill="#FFD074"
      />
      <mask
        id="mask0_5210_47973"
        maskUnits="userSpaceOnUse"
        x={23}
        y={49}
        width={46}
        height={64}
      >
        <path
          d="M47.9431 112.804C41.3448 103.506 27.8864 83.1473 23.0256 53.9402L46.0166 49.9375C50.4871 77.7265 64.1882 93.6649 68.8374 99.8431L47.9431 112.804Z"
          fill="#FF9DBE"
        />
      </mask>
      <g mask="url(#mask0_5210_47973)">
        <path
          d="M30.8867 54.6597C30.8867 54.6597 40.5124 54.3451 46.152 64.3606C51.3003 73.5021 56.966 86.7053 64.5188 95.1582L69.5697 92.9761L50.3162 44.7976L30.8867 54.6597Z"
          fill="#FFB743"
        />
      </g>
      <path
        d="M41.9164 52.3287C44.4346 51.4883 45.9838 50.5917 45.8633 49.9061C45.7428 49.2206 44.0967 48.9289 41.5753 48.963C39.0502 49.0251 36.5358 49.2826 34.0534 49.7335C31.7544 50.1207 29.4847 50.6639 27.2591 51.3594C24.5482 52.2368 22.8612 53.1746 22.9872 53.8784C23.1132 54.5823 24.6858 54.8377 27.1163 54.8269C29.6948 54.7735 32.2627 54.5142 34.797 54.0511C37.2094 53.6541 39.5888 53.0784 41.9164 52.3287V52.3287Z"
        fill="#FFB743"
      />
      <path
        d="M41.9164 52.3287C44.4346 51.4883 45.9838 50.5917 45.8633 49.9061C45.7428 49.2206 44.0967 48.9289 41.5753 48.963C39.0502 49.0251 36.5358 49.2826 34.0534 49.7335C31.7544 50.1207 29.4847 50.6639 27.2591 51.3594C24.5482 52.2368 22.8612 53.1746 22.9872 53.8784C23.1132 54.5823 24.6858 54.8377 27.1163 54.8269C29.6948 54.7735 32.2627 54.5142 34.797 54.0511C37.2094 53.6541 39.5888 53.0784 41.9164 52.3287V52.3287Z"
        stroke="#29292F"
        strokeWidth={0.465478}
        strokeMiterlimit={10}
      />
      <path
        d="M52.8309 27.1738C51.4761 25.4556 49.0376 25.3194 47.2886 26.5611C43.6907 29.1058 40.4817 33.9942 40.4817 33.9942C39.5771 27.3829 39.3049 21.029 39.9978 16.3885C40.2838 14.4281 39.3591 12.3917 37.5534 11.6772C37.0153 11.4597 36.4389 11.3661 35.865 11.4032C35.291 11.4403 34.7336 11.6073 34.2326 11.892C33.7316 12.1767 33.2991 12.5724 32.9659 13.0508C32.6326 13.5292 32.4067 14.0788 32.3044 14.6603C31.5998 18.6136 32.1174 26.2924 32.6653 31.9943L32.3191 32.0548C31.2585 27.4381 29.8599 20.1644 26.997 12.7478C26.6517 11.8347 26.0078 11.0709 25.1773 10.5894C24.3468 10.1079 23.3824 9.93915 22.452 10.1125C21.8958 10.232 21.3732 10.4749 20.9204 10.8246C20.4676 11.1742 20.0956 11.622 19.83 12.1371C19.5645 12.6521 19.4118 13.222 19.3826 13.8072C19.3535 14.3923 19.4485 14.9786 19.6611 15.5254C21.9608 21.6597 23.8165 27.9554 25.213 34.3605L25.0861 34.4383L24.8902 34.5586C23.6688 30.8914 22.1425 27.3357 20.3287 23.9314C19.8566 23.0446 19.0913 22.3589 18.1737 22.001C17.256 21.643 16.248 21.6369 15.3353 21.9835C14.814 22.1974 14.3451 22.5251 13.9606 22.9443C13.5762 23.3635 13.2851 23.8644 13.1074 24.4127C12.9298 24.961 12.8697 25.5438 12.9312 26.1215C12.9927 26.6991 13.1743 27.258 13.4638 27.7599C17.2667 34.3824 20.635 41.0927 25.3904 54.7908C28.9885 55.1918 39.2424 53.8022 44.2146 51.4338C42.8473 45.6545 45.0936 39.5017 51.9733 33.109C53.6729 31.5341 54.3548 29.1083 52.8309 27.1738Z"
        fill="#FFE9A4"
      />
      <path
        d="M21.8156 37.123C21.8156 37.123 24.5631 32.366 36.8198 31.5103"
        stroke="#29292F"
        strokeWidth={0.465478}
        strokeMiterlimit={10}
      />
      <path
        d="M40.4897 34.0096C39.5852 27.3982 39.313 21.0444 40.0059 16.4038C40.2919 14.4435 39.3671 12.407 37.5615 11.6925C37.0233 11.475 36.4469 11.3814 35.873 11.4185C35.2991 11.4557 34.7417 11.6226 34.2406 11.9073C33.7396 12.1921 33.3072 12.5877 32.9739 13.0662C32.6407 13.5446 32.4148 14.0941 32.3124 14.6757C31.6079 18.629 32.1255 26.3078 32.6733 32.0096L32.3209 32.0686C31.2603 27.4519 29.8619 20.1781 26.999 12.7615C26.6536 11.8484 26.0097 11.0846 25.1793 10.6031C24.3488 10.1216 23.3844 9.95282 22.4539 10.1262C21.8978 10.2456 21.3751 10.4886 20.9223 10.8382C20.4696 11.1879 20.0974 11.6358 19.8318 12.1509C19.5662 12.6659 19.4137 13.2357 19.3846 13.8208C19.3554 14.4059 19.4504 14.9923 19.6631 15.5391C21.9627 21.6734 23.8183 27.9692 25.2147 34.3742L24.892 34.5723C23.6706 30.9052 22.1445 27.3494 20.3306 23.9451C19.8586 23.0582 19.0931 22.3727 18.1754 22.0148C17.2578 21.6568 16.2497 21.6507 15.3371 21.9973C14.8157 22.2112 14.3469 22.5389 13.9624 22.9581C13.5779 23.3773 13.287 23.8781 13.1094 24.4264C12.9318 24.9747 12.8716 25.5575 12.9331 26.1351C12.9946 26.7128 13.1763 27.2716 13.4657 27.7735C17.2687 34.3961 20.637 41.1064 25.3924 54.8045C28.8522 55.1926 38.7105 53.9754 44.2166 51.4475C42.8493 45.6682 45.0954 39.5155 51.975 33.1228C53.6623 31.5446 54.3581 29.1157 52.8296 27.1732C51.4748 25.455 49.0363 25.3188 47.2873 26.5605C43.6894 29.1052 40.4803 33.9936 40.4803 33.9936C40.4803 33.9936 35.0743 33.9862 33.0032 39.4673"
        stroke="#29292F"
        strokeWidth={0.465478}
        strokeMiterlimit={10}
      />
    </g>
    <defs>
      <clipPath id="clip0_5210_47973">
        <rect
          width={65}
          height={65}
          rx={32.5}
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);
const SvgMarkBlue = (props: IllustrationProps) => (
  <SVGUniqueID>{Illustration(props)}</SVGUniqueID>
);
export default SvgMarkBlue;
